var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoStreet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "33px",
    viewBox: "0 0 22 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9D6DBD49-2C55-4330-A777-5AD4F4757C02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-323.000000, -735.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "street",
    transform: "translate(323.500000, 735.884277)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-64",
    points: "5.47216797 0.115722656 5.47216797 12.1157227 1.66393131e-13 12.1157227"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-64",
    transform: "translate(18.236084, 6.115723) scale(-1, 1) translate(-18.236084, -6.115723) ",
    points: "20.972168 0.115722656 20.972168 12.1157227 15.5 12.1157227"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-64",
    transform: "translate(2.736084, 26.115723) scale(1, -1) translate(-2.736084, -26.115723) ",
    points: "5.47216797 20.1157227 5.47216797 32.1157227 1.66393131e-13 32.1157227"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-64",
    transform: "translate(18.236084, 26.115723) scale(-1, -1) translate(-18.236084, -26.115723) ",
    points: "20.972168 20.1157227 20.972168 32.1157227 15.5 32.1157227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0 L10.5,3.65942383",
    id: "Path-65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,7 L10.5,10.6594238",
    id: "Path-65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,14 L10.5,17.6594238",
    id: "Path-65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,21 L10.5,24.6594238",
    id: "Path-65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,28 L10.5,31.6594238",
    id: "Path-65"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStreet);
export default __webpack_public_path__ + "static/media/ico_street.e8f336aa13c22d48cdaaeb930642089d.svg";
export { ForwardRef as ReactComponent };